import "../../../src/global.css";
import { useEffect, useState } from "react";
import Header from "../header/Header";
import TopBanner from "../top-banner/TopBanner";
import ProfileInfo from "../profile-info/ProfileInfo";
import SubscriptionForm from "../subscription-form/SubscriptionForm";
import OpinionCarousel from "../Carousel/Carousel";
import AskSection from "../AskSection/AskSection";
import Whatsapp from "../../media/whatsapp.svg";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import SplineSection from "../SplineSection";

function Home() {
  const [blogs, setBlogs] = useState([]);

  const location = useLocation();

  useEffect(() => {
    async function fetchBlogs() {
      try {
        const response = await axios.post(
          "https://9z4ll81nc1.execute-api.us-east-1.amazonaws.com/mylambda2"
        );
        const blogs2 = await response.data;
        setBlogs(blogs2);
      } catch (e) {
        console.error(e);
      }
    }
    fetchBlogs();
  }, []);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: location.pathname,
    });
    ReactGA.event({
      category: "Page View",
      action: "Blog Click",
      label: window.location.pathname,
    });
  }, [location]);
  return (
    <div className="App">


      <Header blogs={blogs} />
      <TopBanner />
      <div className="card-wrapper">
        <SubscriptionForm />
        <ProfileInfo />
      </div>
      <SplineSection />
      <OpinionCarousel />
      <AskSection />
      <h1>Blogs</h1>
      <div className="blogs-footer">
        {blogs.map((blog) => (
          <div className="footer-item">{blog.title}</div>
        ))}
      </div>
      <a href="https://wa.me/573178686858" target="_blank" rel="noreferrer">
        <img
          className="whatsapp-sticky"
          src={Whatsapp}
          alt="medicina interna"
        />
      </a>
    </div>
  );
}

export default Home;
